/* recovered from production bundle — lib/api */
// @ts-nocheck

import { fetchJson, download, streamPost } from './http';
import { serializeFilterClause } from './filters';

export const api = {
  health: () => fetchJson("/api/health"),
  login: (e, t) => fetchJson("/api/auth/login", {
    method: "POST",
    body: JSON.stringify({
      email: e,
      password: t
    })
  }),
  me: () => fetchJson("/api/auth/me"),
  users: () => fetchJson("/api/auth/users"),
  createUser: (e, t, n) => fetchJson("/api/auth/users", {
    method: "POST",
    body: JSON.stringify({
      email: e,
      password: t,
      role: n
    })
  }),
  connections: () => fetchJson("/api/connections"),
  createConnection: e => fetchJson("/api/connections", {
    method: "POST",
    body: JSON.stringify(e)
  }),
  duplicateConnection: e => fetchJson(`/api/connections/${e}/duplicate`, {
    method: "POST"
  }),
  updateConnection: (e, t) => fetchJson(`/api/connections/${e}`, {
    method: "PUT",
    body: JSON.stringify(t)
  }),
  deleteConnection: e => fetchJson(`/api/connections/${e}`, {
    method: "DELETE"
  }),
  testNewConnection: e => fetchJson("/api/connections/test", {
    method: "POST",
    body: JSON.stringify(e)
  }),
  testConnection: e => fetchJson(`/api/connections/${e}/test`, {
    method: "POST"
  }),
  connectionGroups: async () => {
    const e = await fetchJson("/api/connection-groups");
    if (Array.isArray(e)) {
      return e;
    } else {
      return e.groups ?? [];
    }
  },
  createConnectionGroup: (e, t) => fetchJson("/api/connection-groups", {
    method: "POST",
    body: JSON.stringify({
      name: e,
      sortOrder: t
    })
  }),
  updateConnectionGroup: (e, t) => fetchJson(`/api/connection-groups/${e}`, {
    method: "PUT",
    body: JSON.stringify(t)
  }),
  deleteConnectionGroup: e => fetchJson(`/api/connection-groups/${e}`, {
    method: "DELETE"
  }),
  enableConnectionGroupFeatures: (groupId, body = {}) =>
    fetchJson(`/api/connection-groups/${groupId}/enable-features`, {
      method: "POST",
      body: JSON.stringify(body)
    }),
  groupExecute: (groupId, sql, database, multi = true) =>
    fetchJson(`/api/connection-groups/${groupId}/execute`, {
      method: "POST",
      body: JSON.stringify({ sql, database: database ?? null, multi })
    }),
  assignConnectionGroup: (e, t) => fetchJson(`/api/connections/${e}/group`, {
    method: "PUT",
    body: JSON.stringify({
      groupId: t
    })
  }),
  exportConnections: (e = false) => download("/api/connections/export" + (e ? "?includePasswords=1" : ""), e ? "connections-with-passwords.json" : "connections-export.json"),
  importConnections: e => {
    const t = n => fetchJson("/api/connections/import", {
      method: "POST",
      body: n
    }).then(r => {
      var s;
      return {
        imported: r.imported ?? ((s = r.created) == null ? undefined : s.length) ?? 0,
        errors: r.errors ?? r.skipped
      };
    });
    if (typeof e == "string") {
      return t(e);
    } else {
      return e.text().then(t);
    }
  },
  objectDdl: (e, t, n, r) => {
    const s = (Zp[n] ?? Zp.table)(r);
    return fetchJson(`/api/connections/${e}/databases/${encodeURIComponent(t)}/${s}`);
  },
  transferRun: (e, t) => streamPost("/api/transfer/run", {
    method: "POST",
    body: JSON.stringify(e)
  }, t),
  diffSchema: e => fetchJson("/api/diff/schema", {
    method: "POST",
    body: JSON.stringify(e)
  }),
  diffData: e => fetchJson("/api/diff/data", {
    method: "POST",
    body: JSON.stringify(e)
  }),
  databases: e => fetchJson(`/api/connections/${e}/databases`),
  tables: (e, t) => fetchJson(`/api/connections/${e}/databases/${encodeURIComponent(t)}/tables`),
  views: (e, t) => fetchJson(`/api/connections/${e}/databases/${encodeURIComponent(t)}/views`),
  routines: (e, t) => fetchJson(`/api/connections/${e}/databases/${encodeURIComponent(t)}/routines`),
  triggers: (e, t) => fetchJson(`/api/connections/${e}/databases/${encodeURIComponent(t)}/triggers`),
  routineSource: (e, t, n) => fetchJson(`/api/connections/${e}/databases/${encodeURIComponent(t)}/routines/${encodeURIComponent(n)}/source`),
  viewDefinition: (e, t, n) => fetchJson(`/api/connections/${e}/databases/${encodeURIComponent(t)}/views/${encodeURIComponent(n)}/source`),
  tableInfo: (e, t, n) => fetchJson(`/api/connections/${e}/databases/${encodeURIComponent(t)}/tables/${encodeURIComponent(n)}`),
  serverInfo: e => fetchJson(`/api/connections/${e}/server-info`),
  createDatabase: (e, t, n) => fetchJson(`/api/connections/${e}/databases`, {
    method: "POST",
    body: JSON.stringify({
      name: t,
      charset: n
    })
  }),
  dropDatabase: (e, t) => fetchJson(`/api/connections/${e}/databases/${encodeURIComponent(t)}`, {
    method: "DELETE"
  }),
  dropTable: (e, t, n) => fetchJson(`/api/connections/${e}/databases/${encodeURIComponent(t)}/tables/${encodeURIComponent(n)}`, {
    method: "DELETE"
  }),
  dropView: (e, t, n) => fetchJson(`/api/connections/${e}/databases/${encodeURIComponent(t)}/views/${encodeURIComponent(n)}`, {
    method: "DELETE"
  }),
  truncateTable: (e, t, n) => fetchJson(`/api/connections/${e}/databases/${encodeURIComponent(t)}/tables/${encodeURIComponent(n)}/truncate`, {
    method: "POST"
  }),
  renameTable: (e, t, n, r) => fetchJson(`/api/connections/${e}/databases/${encodeURIComponent(t)}/tables/${encodeURIComponent(n)}/rename`, {
    method: "POST",
    body: JSON.stringify({
      newName: r
    })
  }),
  data: (e, t, n, r) => {
    const s = new URLSearchParams();
    s.set("offset", String(r.offset));
    s.set("limit", String(r.limit));
    if (r.sortKeys && r.sortKeys.length > 0) {
      s.set("sortKeys", JSON.stringify(r.sortKeys));
    } else {
      if (r.orderBy) s.set("orderBy", r.orderBy);
      if (r.orderDir) s.set("orderDir", r.orderDir);
    }
    if (r.filter) {
      s.set("filter", r.filter);
    }
    if (r.filters != null) {
      const i = Array.isArray(r.filters) ? r.filters.map(serializeFilterClause) : Array.isArray(r.filters.clauses) ? r.filters.clauses.map(serializeFilterClause) : [];
      const a = JSON.stringify(i);
      s.set("filters", a);
      s.set("structuredFilters", a);
    }
    return fetchJson(`/api/data/${e}/${encodeURIComponent(t)}/${encodeURIComponent(n)}?${s.toString()}`);
  },
  insertRow: (e, t, n, r) => fetchJson(`/api/data/${e}/${encodeURIComponent(t)}/${encodeURIComponent(n)}`, {
    method: "POST",
    body: JSON.stringify(r)
  }),
  updateRow: (e, t, n, r, s) => fetchJson(`/api/data/${e}/${encodeURIComponent(t)}/${encodeURIComponent(n)}`, {
    method: "PUT",
    body: JSON.stringify({
      pk: r,
      data: s
    })
  }),
  deleteRow: (e, t, n, r) => fetchJson(`/api/data/${e}/${encodeURIComponent(t)}/${encodeURIComponent(n)}`, {
    method: "DELETE",
    body: JSON.stringify(r)
  }),
  exportTable: (e, t, n, r) => download(`/api/data/${e}/${encodeURIComponent(t)}/${encodeURIComponent(n)}/export?${r.toString()}`, `${n}.${r.get("format") ?? "json"}`),
  previewTableImport: async (e, t, n, r) => {
    const { getToken, apiPath } = await import("./auth");
    const s = getToken();
    const i = await fetch(apiPath(`/api/data/${e}/${encodeURIComponent(t)}/${encodeURIComponent(n)}/import/preview`), {
      method: "POST",
      headers: s ? { Authorization: `Bearer ${s}` } : {},
      body: r
    });
    if (!i.ok) {
      const a = await i.json().catch(() => ({ error: i.statusText }));
      throw new Error(a.error ?? a.message ?? i.statusText);
    }
    return i.json();
  },
  importTable: async (e, t, n, r) => {
    const { getToken, apiPath } = await import("./auth");
    const s = getToken();
    const i = await fetch(apiPath(`/api/data/${e}/${encodeURIComponent(t)}/${encodeURIComponent(n)}/import`), {
      method: "POST",
      headers: s ? { Authorization: `Bearer ${s}` } : {},
      body: r
    });
    if (!i.ok) {
      const a = await i.json().catch(() => ({ error: i.statusText }));
      throw new Error(a.error ?? a.message ?? i.statusText);
    }
    return i.json();
  },
  execute: (e, t, n, r = true, maxRows: number | undefined = undefined) => fetchJson(`/api/sql/${e}/execute`, {
    method: "POST",
    body: JSON.stringify({
      sql: t,
      database: n,
      multi: r,
      ...(maxRows != null ? { maxRows } : {})
    })
  }),
  vpnStatus: () => fetchJson("/api/vpn/status"),
  vpnUp: () => fetchJson("/api/vpn/up", {
    method: "POST"
  }),
  vpnDown: () => fetchJson("/api/vpn/down", {
    method: "POST"
  }),
  vpnLog: (lines = 200) => fetchJson(`/api/vpn/log?lines=${lines}`),
  vpnStatusForConnection: e => fetchJson(`/api/vpn/${e}/status`),
  vpnUpForConnection: e => fetchJson(`/api/vpn/${e}/up`, {
    method: "POST"
  }),
  vpnDownForConnection: e => fetchJson(`/api/vpn/${e}/down`, {
    method: "POST"
  }),
  processlist: e => fetchJson(`/api/monitor/${e}/processlist`),
  killProcess: (e, t) => fetchJson(`/api/monitor/${e}/kill/${t}`, {
    method: "POST"
  }),
  replicationStatus: (e) => fetchJson(`/api/dba-ops/${e}/replication`),
  indexHealth: (e, database) =>
    fetchJson(`/api/dba-ops/${e}/indexes${database ? `?database=${encodeURIComponent(database)}` : ''}`),
  tableFragmentation: (e, database) =>
    fetchJson(`/api/dba-ops/${e}/fragmentation${database ? `?database=${encodeURIComponent(database)}` : ''}`),
  schemaRecommendations: (e, database) =>
    fetchJson(`/api/dba-ops/${e}/recommendations${database ? `?database=${encodeURIComponent(database)}` : ''}`),
  idleSessions: (e, minSec = 60) => fetchJson(`/api/dba-ops/${e}/idle-sessions?minSec=${minSec}`),
  killSession: (e, pid) => fetchJson(`/api/dba-ops/${e}/kill-session`, {
    method: "POST",
    body: JSON.stringify({ pid })
  }),
  superKill: (e, database) => fetchJson(`/api/dba-ops/${e}/superkill`, {
    method: "POST",
    body: JSON.stringify({ database })
  }),
  maintenanceRun: (e, t, n) => streamPost(`/api/dba-ops/${e}/maintenance/run`, {
    method: "POST",
    body: JSON.stringify(t)
  }, n),
  maintenanceSchedule: (e, t) => fetchJson(`/api/dba-ops/${e}/maintenance/schedule`, {
    method: "POST",
    body: JSON.stringify(t)
  }),
  engineUsers: e => fetchJson(`/api/engine-users/${e}`),
  createEngineUser: (e, t) => fetchJson(`/api/engine-users/${e}`, {
    method: "POST",
    body: JSON.stringify(t)
  }),
  connectionGrants: (connId) => fetchJson(`/api/connections/${connId}/grants`),
  upsertConnectionGrant: (connId, userId, role) => fetchJson(`/api/connections/${connId}/grants`, {
    method: "POST",
    body: JSON.stringify({ userId, role })
  }),
  deleteConnectionGrant: (connId, userId) => fetchJson(`/api/connections/${connId}/grants/${encodeURIComponent(userId)}`, {
    method: "DELETE"
  }),
  grant: (e, t) => fetchJson(`/api/engine-users/${e}/grant`, {
    method: "POST",
    body: JSON.stringify(t)
  }),
  revoke: (e, t) => fetchJson(`/api/engine-users/${e}/revoke`, {
    method: "POST",
    body: JSON.stringify(t)
  }),
  engineUserBatchPreview: (e, t) => fetchJson(`/api/engine-users/${e}/batch-preview`, {
    method: "POST",
    body: JSON.stringify(t)
  }),
  engineUserBatchApply: (e, t) => fetchJson(`/api/engine-users/${e}/batch-apply`, {
    method: "POST",
    body: JSON.stringify(t)
  }),
  deleteEngineUser: (e, t, n = "%") => fetchJson(`/api/engine-users/${e}/${encodeURIComponent(t)}?host=${encodeURIComponent(n)}`, {
    method: "DELETE"
  }),
  alterEngineUserLimits: (e, t, n, r) => fetchJson(`/api/engine-users/${e}/${encodeURIComponent(t)}/limits`, {
    method: "POST",
    body: JSON.stringify({ host: n ?? "%", limits: r ?? null })
  }),
  alterDatabaseConnectionLimit: (e, t, n) => fetchJson(`/api/engine-users/${e}/databases/${encodeURIComponent(t)}/connection-limit`, {
    method: "POST",
    body: JSON.stringify({ limit: n })
  }),
  pgDatabaseLimits: (e) => fetchJson(`/api/engine-users/${e}/database-limits`),
  designerOpen: (e, t, n) => fetchJson(`/api/designer/${e}/${encodeURIComponent(t)}/${encodeURIComponent(n)}`),
  designerPreview: (e, t, n) => fetchJson(`/api/designer/${e}/${encodeURIComponent(t)}/preview`, {
    method: "POST",
    body: JSON.stringify(n)
  }),
  designerApply: (e, t, n) => fetchJson(`/api/designer/${e}/${encodeURIComponent(t)}/apply`, {
    method: "POST",
    body: JSON.stringify(n)
  }),
  erGet: (e, t) => fetchJson(`/api/er/${e}/${encodeURIComponent(t)}`),
  erPositions: (e, t, n) => fetchJson(`/api/er/${e}/${encodeURIComponent(t)}/positions`, {
    method: "PUT",
    body: JSON.stringify(n)
  }),
  explain: (e, t, n, r = false) => fetchJson(`/api/explain/${e}`, {
    method: "POST",
    body: JSON.stringify({
      sql: t,
      database: n,
      analyze: r
    })
  }),
  savedQueries: e => fetchJson(`/api/queries/${e}`),
  saveQuery: (e, t, n) => fetchJson(`/api/queries/${e}`, {
    method: "POST",
    body: JSON.stringify({
      title: t,
      sql: n
    })
  }),
  updateSavedQuery: (e, t) => fetchJson(`/api/queries/${e}`, {
    method: "PUT",
    body: JSON.stringify(t)
  }),
  deleteSavedQuery: e => fetchJson(`/api/queries/${e}`, {
    method: "DELETE"
  }),
  backupRun: (e, t, n) => streamPost(`/api/backup/${e}/run`, {
    method: "POST",
    body: JSON.stringify(t)
  }, n),
  backupList: (e, t) => {
    const n = t ? `?database=${encodeURIComponent(t)}` : "";
    return fetchJson(`/api/backup/${e}/list${n}`);
  },
  backupRestore: (e, t, n) => streamPost(`/api/backup/${e}/restore`, {
    method: "POST",
    body: JSON.stringify(t)
  }, n),
  smartBackupRun: (e, t, n) => streamPost(`/api/backup/${e}/smart-run`, {
    method: "POST",
    body: JSON.stringify(t)
  }, n),
  smartBackupManifest: (e) => fetchJson(`/api/backup/manifest/${e}`),
  smartBackupRestore: (e, t, n) => streamPost(`/api/backup/${e}/smart-restore`, {
    method: "POST",
    body: JSON.stringify(t)
  }, n),
  backupVerify: (connId, backupId, onEvent) => streamPost(`/api/backup/${connId}/verify/${backupId}`, {
    method: "POST",
    body: JSON.stringify({})
  }, onEvent),
  backupVerifyStatus: (backupId) => fetchJson(`/api/backup/verify-status/${backupId}`),
  auditLog: (opts: { page?: number; limit?: number; action?: string; target?: string } = {}) => {
    const p = new URLSearchParams();
    if (opts.page)   p.set('page',   String(opts.page));
    if (opts.limit)  p.set('limit',  String(opts.limit));
    if (opts.action) p.set('action', opts.action);
    if (opts.target) p.set('target', opts.target);
    const qs = p.toString();
    return fetchJson(`/api/audit${qs ? '?' + qs : ''}`);
  },
  purgeAuditLog: (olderThanDays = 90) =>
    fetchJson(`/api/audit?olderThanDays=${olderThanDays}`, { method: "DELETE" }),
  sqlHistory: (connId, opts: { database?: string; limit?: number } = {}) => {
    const p = new URLSearchParams();
    if (opts.database) p.set('database', opts.database);
    if (opts.limit)    p.set('limit', String(opts.limit));
    const qs = p.toString();
    return fetchJson(`/api/history/${connId}${qs ? '?' + qs : ''}`);
  },
  appendHistory: (connId, entry) => fetchJson(`/api/history/${connId}`, {
    method: "POST",
    body: JSON.stringify(entry)
  }),
  clearHistory: (connId) => fetchJson(`/api/history/${connId}`, { method: "DELETE" }),
  deleteHistoryEntry: (connId, id) => fetchJson(`/api/history/${connId}/${encodeURIComponent(id)}`, { method: "DELETE" }),
  systemVersion: () => fetchJson("/api/system/version"),
  systemUpdate: (onEvent) => streamPost("/api/system/update", { method: "POST", body: JSON.stringify({}) }, onEvent),
  scheduledJobs: () => fetchJson("/api/scheduled-jobs"),
  createScheduledJob: (body) => fetchJson("/api/scheduled-jobs", { method: "POST", body: JSON.stringify(body) }),
  updateScheduledJob: (id, body) => fetchJson(`/api/scheduled-jobs/${id}`, { method: "PUT", body: JSON.stringify(body) }),
  deleteScheduledJob: (id) => fetchJson(`/api/scheduled-jobs/${id}`, { method: "DELETE" }),
  runScheduledJobNow: (id) => fetchJson(`/api/scheduled-jobs/${id}/run-now`, { method: "POST", body: "{}" }),
  scheduledJobRuns: (id, limit = 20) => fetchJson(`/api/scheduled-jobs/${id}/runs?limit=${limit}`),
  schedulerStatus: () => fetchJson('/api/scheduler/status'),
  notificationsStatus: () => fetchJson('/api/notifications/status'),
  collectorMetrics: (hours = 24) => fetchJson(`/api/scheduler/collector-metrics?hours=${hours}`),
  collectorUptime: (days = 7) => fetchJson(`/api/scheduler/collector-uptime?days=${days}`),
  collectorConfigAudit: () => fetchJson('/api/scheduler/collector-config'),
  staleCollectors: () => fetchJson('/api/scheduler/stale-collectors'),
  recoverStaleCollectors: (connectionIds) => fetchJson('/api/scheduler/recover-stale-collectors', {
    method: 'POST',
    body: JSON.stringify(connectionIds?.length ? { connectionIds } : {}),
  }),
  schedulerRepair: (onEvent) => streamPost('/api/scheduler/repair', { method: 'POST', body: '{}' }, onEvent),
  dbJobs: (connId, database) => {
    const q = database ? `?database=${encodeURIComponent(database)}` : '';
    return fetchJson(`/api/connections/${connId}/db-jobs${q}`);
  },
  dbJob: (connId, jobId) => fetchJson(`/api/connections/${connId}/db-jobs/${encodeURIComponent(jobId)}`),
  dbJobHistory: (connId, jobId) => fetchJson(`/api/connections/${connId}/db-jobs/${encodeURIComponent(jobId)}/history`),
  dbJobEnable: (connId, jobId) => fetchJson(`/api/connections/${connId}/db-jobs/${encodeURIComponent(jobId)}/enable`, { method: 'POST', body: '{}' }),
  dbJobDisable: (connId, jobId) => fetchJson(`/api/connections/${connId}/db-jobs/${encodeURIComponent(jobId)}/disable`, { method: 'POST', body: '{}' }),
  dbJobRun: (connId, jobId) => fetchJson(`/api/connections/${connId}/db-jobs/${encodeURIComponent(jobId)}/run`, { method: 'POST', body: '{}' }),
  dbJobDrop: (connId, jobId) => fetchJson(`/api/connections/${connId}/db-jobs/${encodeURIComponent(jobId)}`, { method: 'DELETE' }),
  logsConfig: (connId) => fetchJson(`/api/connections/${connId}/logs`),
  logsSlowQuery: (connId, limit = 50) => fetchJson(`/api/connections/${connId}/logs/slow-query?limit=${limit}`),
  logsGeneral: (connId, limit = 100) => fetchJson(`/api/connections/${connId}/logs/general?limit=${limit}`),
  queryStoreStatus: (connId) => fetchJson(`/api/connections/${connId}/query-store/status`),
  queryStoreStatusLive: (connId) => fetchJson(`/api/connections/${connId}/query-store/status?live=1`),
  queryStoreTop: (connId, limit = 25) => fetchJson(`/api/connections/${connId}/query-store/top?limit=${limit}`),
  queryStoreReset: (connId) => fetchJson(`/api/connections/${connId}/query-store/reset`, { method: 'POST', body: '{}' }),
  queryStoreEnable: (connId) =>
    fetchJson(`/api/connections/${connId}/query-store/enable`, { method: 'POST', body: '{}' }),
  queryStoreConfig: (connId) => fetchJson(`/api/connections/${connId}/query-store/config`),
  queryStoreUpdateConfig: (connId, body) =>
    fetchJson(`/api/connections/${connId}/query-store/config`, { method: 'PUT', body: JSON.stringify(body) }),
  queryStoreSnapshot: (connId) =>
    fetchJson(`/api/connections/${connId}/query-store/snapshot`, { method: 'POST', body: '{}' }),
  queryStoreSnapshots: (connId, limit = 50) =>
    fetchJson(`/api/connections/${connId}/query-store/snapshots?limit=${limit}`),
  queryStoreRegressions: (connId, limit = 50) =>
    fetchJson(`/api/connections/${connId}/query-store/regressions?limit=${limit}`),
  queryStoreQueries: (connId, limit = 100) =>
    fetchJson(`/api/connections/${connId}/query-store/queries?limit=${limit}`),
  queryStoreGetQuery: (connId, queryId) =>
    fetchJson(`/api/connections/${connId}/query-store/queries/${encodeURIComponent(queryId)}`),
  queryStoreResolve: (connId, { schema = '', digest = '', digestText = '' } = {}) => {
    const qs = new URLSearchParams();
    if (schema) qs.set('schema', schema);
    if (digest) qs.set('digest', digest);
    if (digestText) qs.set('digestText', digestText);
    return fetchJson(`/api/connections/${connId}/query-store/queries/resolve?${qs}`);
  },
  queryStoreDashboard: (connId, { window = '24h', schema = '', limit = 100 } = {}) => {
    const qs = new URLSearchParams({ window, limit: String(limit) });
    if (schema) qs.set('schema', schema);
    return fetchJson(`/api/connections/${connId}/query-store/dashboard?${qs}`);
  },
  queryStoreHourlyTrend: (connId: string, days = 7) =>
    fetchJson(`/api/connections/${connId}/query-store/hourly-trend?days=${days}`),
  queryStoreQueryHistory: (connId, queryId, limit = 30) =>
    fetchJson(`/api/connections/${connId}/query-store/queries/${encodeURIComponent(queryId)}/history?limit=${limit}`),
  queryStoreQueryPlans: (connId, queryId, limit = 50, capture = false) => {
    const qs = new URLSearchParams({ limit: String(limit) });
    if (capture) qs.set('capture', '1');
    return fetchJson(`/api/connections/${connId}/query-store/queries/${encodeURIComponent(queryId)}/plans?${qs}`);
  },
  queryStoreQueryOrigin: (connId, queryId) =>
    fetchJson(`/api/connections/${connId}/query-store/queries/${encodeURIComponent(queryId)}/origin`),
  queryStoreOriginTimeline: (connId, queryId, window = '1h') =>
    fetchJson(`/api/connections/${connId}/query-store/queries/${encodeURIComponent(queryId)}/origin/timeline?window=${window}`),
  queryStoreOriginSummary: (connId, limit = 15) =>
    fetchJson(`/api/connections/${connId}/query-store/origin/summary?limit=${limit}`),
  queryStoreForcedPlan: (connId, queryId) =>
    fetchJson(`/api/connections/${connId}/query-store/queries/${encodeURIComponent(queryId)}/forced-plan`),
  queryStoreSetForcedPlan: (connId, queryId, hintSql, active = true, planHash = null) =>
    fetchJson(`/api/connections/${connId}/query-store/queries/${encodeURIComponent(queryId)}/forced-plan`, {
      method: 'POST',
      body: JSON.stringify({ hintSql, active, planHash }),
    }),
  queryStoreRecommendations: (connId, queryId) =>
    fetchJson(`/api/connections/${connId}/query-store/queries/${encodeURIComponent(queryId)}/recommendations`),
  queryStoreAiAnalysis: (connId, queryId, analysis) =>
    fetchJson(`/api/connections/${connId}/query-store/queries/${encodeURIComponent(queryId)}/ai-analysis`, {
      method: 'POST',
      body: JSON.stringify({ analysis }),
    }),
  /** Generic AI analysis endpoint. Backend assembles the payload for the
   *  given `kind` (reusing existing services), except `explain`/`explain-compare`
   *  where the client passes the already-computed plan in `params`. */
  aiAnalysis: (connId, kind, params = {}) =>
    fetchJson(`/api/connections/${connId}/ai/analysis`, {
      method: 'POST',
      body: JSON.stringify({ kind, params }),
    }),
  /** Cross-connection fleet AI analysis. */
  aiFleetAnalysis: (connectionIds, params = {}) =>
    fetchJson('/api/dpa/ai/fleet-analysis', {
      method: 'POST',
      body: JSON.stringify({ connectionIds, params }),
    }),
  dpaFleetSummary: (connectionIds: string[]) =>
    fetchJson('/api/dpa/fleet-summary', { method: 'POST', body: JSON.stringify({ connectionIds }) }),
  dpaFleetCharts: (connectionIds: string[], window = '24h') =>
    fetchJson('/api/dpa/fleet-charts', { method: 'POST', body: JSON.stringify({ connectionIds, window }) }),
  dpaQueryWaits: (connId: string, queryId: string, window = '24h') =>
    fetchJson(`/api/connections/${connId}/dpa/queries/${encodeURIComponent(queryId)}/waits?window=${window}`),
  dpaWaits: (connId) => fetchJson(`/api/connections/${connId}/dpa/waits`),
  dpaBlocking: (connId) => fetchJson(`/api/connections/${connId}/dpa/blocking`),
  dpaResources: (connId) => fetchJson(`/api/connections/${connId}/dpa/resources`),
  dpaEvents: (connId) => fetchJson(`/api/connections/${connId}/dpa/events`),
  dpaWorkload: (connId, window = '24h') => fetchJson(`/api/connections/${connId}/dpa/workload?window=${window}`),
  dpaTrends: (connId: string, window = '24h', tab = 'waits') => fetchJson(`/api/connections/${connId}/dpa/trends?window=${window}&tab=${tab}`),
  dpaQueryDetail: (connId: string, queryId: string, window = '24h') => fetchJson(`/api/connections/${connId}/dpa/queries/${encodeURIComponent(queryId)}/detail?window=${window}`),
  dpaFindSql: (connId: string, params: { q?: string; from?: string; to?: string; app?: string; limit?: number }) => {
    const qs = new URLSearchParams();
    if (params.q) qs.set('q', params.q);
    if (params.from) qs.set('from', params.from);
    if (params.to) qs.set('to', params.to);
    if (params.app) qs.set('app', params.app);
    if (params.limit) qs.set('limit', String(params.limit));
    return fetchJson(`/api/connections/${connId}/dpa/find-sql?${qs}`);
  },
  dpaBlockingHistory: (connId: string, limit = 100) => fetchJson(`/api/connections/${connId}/dpa/blocking/history?limit=${limit}`),
  dpaCapacity: (connId) => fetchJson(`/api/connections/${connId}/dpa/capacity`),
  dpaHealth: (connId) => fetchJson(`/api/connections/${connId}/dpa/health`),
  dpaHealthLive: (connId) => fetchJson(`/api/connections/${connId}/dpa/health?live=1`),
  dpaBlockingLive: (connId) => fetchJson(`/api/connections/${connId}/dpa/blocking?live=1`),
  dpaAttribution: (connId, queryId, view = 'consumers') =>
    fetchJson(`/api/connections/${connId}/dpa/queries/${encodeURIComponent(queryId)}/attribution?view=${view}`),
  dpaExplain: (connId, body) =>
    fetchJson(`/api/connections/${connId}/dpa/explain`, { method: 'POST', body: JSON.stringify(body ?? {}) }),
  dpaAiAssist: (connId, sql, plan) =>
    fetchJson(`/api/connections/${connId}/dpa/ai-assist`, { method: 'POST', body: JSON.stringify({ sql, plan }) }),
  dpaAnomalies: (connId: string) => fetchJson(`/api/connections/${connId}/dpa/anomalies`),
  dpaTableAdvisor: (connId: string) => fetchJson(`/api/connections/${connId}/dpa/table-advisor`),
  dpaIndexAdvisor: (connId: string) => fetchJson(`/api/connections/${connId}/dpa/index-advisor`),
  dpaDeadlocks: (connId: string) => fetchJson(`/api/connections/${connId}/dpa/deadlocks`),
  dpaAlerts: (connId: string, limit = 50) => fetchJson(`/api/connections/${connId}/dpa/alerts?limit=${limit}`),
  dpaWaitAnalysis: (connId: string, dimension = 'query', window = '24h', limit = 50) =>
    fetchJson(`/api/connections/${connId}/dpa/wait-analysis?dimension=${dimension}&window=${window}&limit=${limit}`),
  dpaCollectorStatus: (connId: string) => fetchJson(`/api/connections/${connId}/dpa/collector-status`),
  dpaHourlyTrends: (connId: string, days = 7) =>
    fetchJson(`/api/connections/${connId}/dpa/hourly-trends?days=${days}`),
  dpaBlockingRecords: (connId: string, limit = 100) =>
    fetchJson(`/api/connections/${connId}/dpa/blocking/history?limit=${limit}`),
  dpaBlockingTopBlockers: (connId: string, window = '7d') =>
    fetchJson(`/api/connections/${connId}/dpa/blocking/top-blockers?window=${window}`),
  dpaBlockingTopVictims: (connId: string, window = '7d') =>
    fetchJson(`/api/connections/${connId}/dpa/blocking/top-victims?window=${window}`),
  dpaBlockingHeatmap: (connId: string, window = '7d') =>
    fetchJson(`/api/connections/${connId}/dpa/blocking/heatmap?window=${window}`),
  dpaSessions: (connId: string) => fetchJson(`/api/connections/${connId}/dpa/sessions`),
  dpaSessionsCapture: (connId: string) =>
    fetchJson(`/api/connections/${connId}/dpa/sessions/capture`, { method: 'POST', body: '{}' }),
  dpaLogs: (connId: string, limit = 80) =>
    fetchJson(`/api/connections/${connId}/dpa/logs?limit=${limit}`),
  dpaSnapshot: (connId) =>
    fetchJson(`/api/connections/${connId}/dpa/snapshot`, { method: 'POST', body: '{}' }),
  dpaKeepAlive: (connId: string) =>
    fetchJson(`/api/connections/${connId}/dpa/keep-alive`, { method: 'POST', body: '{}' }),
  dpaWaitDetail: (connId: string, waitClass: string, window = '1h') =>
    fetchJson(`/api/connections/${connId}/dpa/waits/${encodeURIComponent(waitClass)}/detail?window=${window}`),
  dpaFleetStatusSummary: (connectionIds: string[]) => {
    const qs = connectionIds.map((id) => `connectionIds=${encodeURIComponent(id)}`).join('&');
    return fetchJson(`/api/dpa/fleet-status?${qs}`);
  },
  dpaFleetMonitoring: () => fetchJson('/api/dpa/fleet-monitoring'),
  dpaPutFleetMonitoring: (enabled: boolean) =>
    fetchJson('/api/dpa/fleet-monitoring', { method: 'PUT', body: JSON.stringify({ enabled }) }),
  connectionSetMonitoring: (connId: string, enabled: boolean) =>
    fetchJson(`/api/connections/${encodeURIComponent(connId)}/monitoring`, {
      method: 'PUT',
      body: JSON.stringify({ enabled }),
    }),
  dpaCriticalSummary: () => fetchJson('/api/dpa/critical-summary'),
  dpaAlertRecommendations: (alert) =>
    fetchJson('/api/dpa/alert-recommendations', {
      method: 'POST',
      body: JSON.stringify(alert ?? {}),
    }),
  dpaAcknowledgeAlert: (alert, reviewIntervalSec = 3600) =>
    fetchJson('/api/dpa/alerts/acknowledge', {
      method: 'POST',
      body: JSON.stringify({ alert, reviewIntervalSec }),
    }),
  dpaAcknowledgeAlertsBatch: (alerts, reviewIntervalSec = 3600) =>
    fetchJson('/api/dpa/alerts/acknowledge-batch', {
      method: 'POST',
      body: JSON.stringify({ alerts, reviewIntervalSec }),
    }),
  dpaUnacknowledgeAlert: (alertKey) =>
    fetchJson('/api/dpa/alerts/acknowledge', {
      method: 'DELETE',
      body: JSON.stringify({ alertKey }),
    }),
  dpaBlackouts: () => fetchJson('/api/dpa/blackouts'),
  dpaCreateBlackout: (payload) =>
    fetchJson('/api/dpa/blackouts', {
      method: 'POST',
      body: JSON.stringify(payload ?? {}),
    }),
  dpaDeleteBlackout: (id) =>
    fetchJson(`/api/dpa/blackouts/${encodeURIComponent(id)}`, { method: 'DELETE' }),
  dpaAlertRules: () => fetchJson('/api/dpa/alert-rules'),
  dpaUpdateAlertRule: (payload) =>
    fetchJson('/api/dpa/alert-rules', {
      method: 'PUT',
      body: JSON.stringify(payload ?? {}),
    }),
  settingsSnapshot: () => fetchJson('/api/settings'),
  settingsUi: () => fetchJson('/api/settings/ui'),
  settingsPutUi: (body) => fetchJson('/api/settings/ui', { method: 'PUT', body: JSON.stringify(body ?? {}) }),
  settingsNotifications: () => fetchJson('/api/settings/notifications'),
  settingsPutNotifications: (body) => fetchJson('/api/settings/notifications', { method: 'PUT', body: JSON.stringify(body ?? {}) }),
  settingsTestNotification: () => fetchJson('/api/settings/notifications/test', { method: 'POST' }),
  settingsEmailChannel: () => fetchJson('/api/settings/notifications/email'),
  settingsPutEmailChannel: (body) => fetchJson('/api/settings/notifications/email', { method: 'PUT', body: JSON.stringify(body ?? {}) }),
  settingsWebhookChannel: () => fetchJson('/api/settings/notifications/webhook'),
  settingsPutWebhookChannel: (body) => fetchJson('/api/settings/notifications/webhook', { method: 'PUT', body: JSON.stringify(body ?? {}) }),
  settingsAlerts: (connectionId) => fetchJson(`/api/settings/alerts${connectionId ? `?connectionId=${encodeURIComponent(connectionId)}` : ''}`),
  settingsPutAlerts: (body) => fetchJson('/api/settings/alerts', { method: 'PUT', body: JSON.stringify(body ?? {}) }),
  settingsBlackouts: () => fetchJson('/api/settings/blackouts'),
  settingsCreateBlackout: (body) => fetchJson('/api/settings/blackouts', { method: 'POST', body: JSON.stringify(body ?? {}) }),
  settingsDeleteBlackout: (id) => fetchJson(`/api/settings/blackouts/${encodeURIComponent(id)}`, { method: 'DELETE' }),
  settingsCorrelation: () => fetchJson('/api/settings/correlation'),
  settingsPutCorrelation: (body) => fetchJson('/api/settings/correlation', { method: 'PUT', body: JSON.stringify(body ?? {}) }),
  settingsCollector: () => fetchJson('/api/settings/collector'),
  settingsPutCollector: (body) => fetchJson('/api/settings/collector', { method: 'PUT', body: JSON.stringify(body ?? {}) }),
  settingsQueryStore: (connectionId) => fetchJson(`/api/settings/query-store${connectionId ? `?connectionId=${encodeURIComponent(connectionId)}` : ''}`),
  settingsPutQueryStore: (body) => fetchJson('/api/settings/query-store', { method: 'PUT', body: JSON.stringify(body ?? {}) }),
  settingsHealth: () => fetchJson('/api/settings/health'),
  settingsPutHealth: (body) => fetchJson('/api/settings/health', { method: 'PUT', body: JSON.stringify(body ?? {}) }),
  settingsRetention: () => fetchJson('/api/settings/retention'),
  settingsPutRetention: (body) => fetchJson('/api/settings/retention', { method: 'PUT', body: JSON.stringify(body ?? {}) }),
  settingsRetentionPurge: () => fetchJson('/api/settings/retention/purge', { method: 'POST' }),
  settingsUsers: () => fetchJson('/api/settings/users'),
  settingsCreateUser: (email, password, role) => fetchJson('/api/settings/users', {
    method: 'POST',
    body: JSON.stringify({ email, password, role }),
  }),
  settingsUpdateUserRole: (id, role) => fetchJson(`/api/auth/users/${id}/role`, {
    method: 'PUT',
    body: JSON.stringify({ role }),
  }),
  settingsChangeUserPassword: (id, password) => fetchJson(`/api/auth/users/${id}/password`, {
    method: 'PUT',
    body: JSON.stringify({ password }),
  }),
  settingsDeleteUser: (id) => fetchJson(`/api/auth/users/${id}`, { method: 'DELETE' }),
  settingsInfra: () => fetchJson('/api/settings/infra'),
  settingsAiOpenAi: () => fetchJson('/api/settings/ai/openai'),
  settingsPutAiOpenAi: (body) => fetchJson('/api/settings/ai/openai', { method: 'PUT', body: JSON.stringify(body ?? {}) }),
  settingsTestAiOpenAi: () => fetchJson('/api/settings/ai/openai/test', { method: 'POST' }),
  collectorRuntime: () => fetchJson('/api/scheduler/collector-runtime'),
  collectorPutRuntime: (collector) => fetchJson('/api/scheduler/collector-runtime', {
    method: 'PUT',
    body: JSON.stringify({ collector }),
  }),
  /** OS terminal: host shell availability (admin). */
  osTerminalStatus: () => fetchJson('/api/os-terminal/status'),
  /** OS terminal: short-lived JWT to open the PTY websocket (admin). */
  osTerminalToken: () => fetchJson('/api/os-terminal/token', { method: 'POST' }),

  /** OS terminal: snippet library (admin). */
  osTerminalSnippets: () => fetchJson('/api/os-terminal/snippets'),
  osTerminalCreateSnippet: (body) => fetchJson('/api/os-terminal/snippets', {
    method: 'POST', body: JSON.stringify(body),
  }),
  osTerminalUpdateSnippet: (id, body) => fetchJson(`/api/os-terminal/snippets/${id}`, {
    method: 'PUT', body: JSON.stringify(body),
  }),
  osTerminalDeleteSnippet: (id) => fetchJson(`/api/os-terminal/snippets/${id}`, { method: 'DELETE' }),

  /** OS terminal: file repository on the host (admin). */
  osTerminalListFiles: (path = '') => fetchJson(`/api/os-terminal/files?path=${encodeURIComponent(path)}`),
  osTerminalReadFile: (path) => fetchJson(`/api/os-terminal/files?path=${encodeURIComponent(path)}`),
  osTerminalWriteFile: (path, content) => fetchJson('/api/os-terminal/files', {
    method: 'POST', body: JSON.stringify({ path, content, action: 'write' }),
  }),
  osTerminalMkdir: (path) => fetchJson('/api/os-terminal/files', {
    method: 'POST', body: JSON.stringify({ path, action: 'mkdir' }),
  }),
  osTerminalDeleteFile: (path) => fetchJson(`/api/os-terminal/files?path=${encodeURIComponent(path)}`, { method: 'DELETE' }),
};
